module.exports = __webpack_public_path__ + "img/9788971847541.5df10367.jpg";